import { Button } from '@/components/ui/button'
// apps/app/src/routes/notifications/root.tsx
import { DataGuard } from '@components/DataGuard'
import LayoutHeader from '@components/LayoutHeader'
import Panel from '@components/Panel'
import { useNotifications } from '@stateApp'
import { For, Show, createEffect, onCleanup } from 'solid-js'
import { useService } from 'solid-services'
import { cx } from 'styled-system/css'
import { Container, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'
import NotificationComponent from '../../features/Notifications/Notification'

export default function () {
  const { notificationsQuery, clearAllNotificationsMutation } = useService(useNotifications)()

  let sentinelRef: HTMLDivElement | undefined

  // Helper to flatten pages from infinite query
  const allNotifications = () => notificationsQuery.data?.pages.flatMap((page) => page.data) || []

  const handleClearAll = () => {
    clearAllNotificationsMutation.mutate()
  }

  // Setup intersection observer for infinite scroll
  createEffect(() => {
    if (!sentinelRef) return

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && notificationsQuery.hasNextPage && !notificationsQuery.isFetchingNextPage) {
        notificationsQuery.fetchNextPage()
      }
    })

    observer.observe(sentinelRef)

    onCleanup(() => {
      observer.disconnect()
    })
  })

  return (
    <Grid gridTemplateRows='auto 1fr' gap={0}>
      <LayoutHeader
        title="Notifications"
        rightContent={
          <Show when={allNotifications().length > 0}>
            <Button
              size='sm'
              variant='outline'
              colorPalette='jade'
              onClick={handleClearAll}
              disabled={clearAllNotificationsMutation.isPending}
            >
              {clearAllNotificationsMutation.isPending ? 'Clearing...' : 'Clear all'}
            </Button>
          </Show>
        }
      />
      <Panel
        height='calc(var(--vh) * 100 - 60px)'
        overflowY='auto'
        class={cx(scrollbar())}
        alignContent='start'
        gridAutoRows={'max-content'}
      >
        <Container display='grid' gap={3}>
          <DataGuard query={notificationsQuery}>
            {() => (
              <>
                <For each={allNotifications()}>
                  {(notification) => <NotificationComponent notification={notification} />}
                </For>

                {/* Sentinel for Intersection Observer */}
                <div ref={sentinelRef} class="h-4 w-full flex items-center justify-center">
                  <Show when={notificationsQuery.isFetchingNextPage}>
                    <span class="text-xs text-neutral-400">Loading more...</span>
                  </Show>
                </div>
              </>
            )}
          </DataGuard>
        </Container>
      </Panel>
    </Grid>
  )
}
